import { useEffect, useState } from "react";
import {
  Button,
  Input,
  Layout,
  Pagination,
  Select,
  Table,
  Modal,
  Descriptions,
  Typography,
} from "antd";
import { toast } from "sonner";
import DashboardCard from "../admin/Summary/child-comp/DashboardCard";
import {
  getCompanyList,
  getListData,
  getOverviewData,
  getVendorList,
} from "../../services/vendorBills";
import dayjs from "dayjs";

const { Option } = Select;
const { Title } = Typography;
const { Content } = Layout;

// Dummy Data
const dashboardCards = [
  {
    id: "totalInvoices",
    navigateId: null,
    title: "Invoices",
    value: 0,
    color: "text-blue-600",
    bgColor: "bg-blue-50",
    hoverColor: "hover:bg-blue-100",
  },
  {
    id: "paidInvoices",
    navigateId: null,
    title: "Payment Done",
    value: 0,
    color: "text-green-600",
    bgColor: "bg-green-50",
    hoverColor: "hover:bg-green-100",
  },
  {
    id: "pendingInvoices",
    navigateId: null,
    title: "Pending Invoices",
    value: 0,
    color: "text-orange-600",
    bgColor: "bg-orange-50",
    hoverColor: "hover:bg-orange-100",
  },
  {
    id: "tdsDeductedCount",
    navigateId: null,
    title: "TDS Deducted",
    value: 0,
    color: "text-red-600",
    bgColor: "bg-red-50",
    hoverColor: "hover:bg-red-100",
  },
  {
    id: "tdsDepositedCount",
    navigateId: null,
    title: "TDS Deposited",
    value: 0,
    color: "text-purple-600",
    bgColor: "bg-purple-50",
    hoverColor: "hover:bg-purple-100",
  },
];

const Vendorbills = () => {
  // O V E R V I E W
  const [overview, setOverview] = useState(dashboardCards);
  // O P T I O N S
  const [companyOptions, setCompanyOptions] = useState([]);
  const [vendorOptions, setVendorOptions] = useState([]);

  // List Data
  const [listItemModalDetails, setLIstItemModalDetails] = useState({
    paymentDate: null,
    tdsDeducted: null,
    paymentTxnId: null,
    isOpen: false,
  });
  const [listData, setListData] = useState([]);
  const [totalLengthListData, setTotalLengthListData] = useState(0);
  const columns = [
    {
      title: "Vendor Name",
      dataIndex: "vendorName",
      key: "vendorName",
    },
    {
      title: "Invoice No",
      dataIndex: "invoiceNo",
      key: "invoiceNo",
    },
    {
      title: "Month",
      dataIndex: "month",
      key: "month",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "Payment Status",
      dataIndex: "paymentStatus",
      key: "paymentStatus",
      render: (text) => text.charAt(0).toUpperCase() + text.slice(1),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button
            type="primary"
            style={{
              backgroundColor: "#0471a3",
              borderColor: "#0471a3",
              color: "#fff",
              cursor: "pointer",
              boxShadow: "none",
            }}
            onClick={() => {
              debugger;
              setLIstItemModalDetails({
                paymentDate: record.paymentDate,
                tdsDeducted: record.tdsDeducted,
                paymentTxnId: record.paymentTxnId,
                isOpen: true,
              });
            }}
          >
            View Details
          </Button>
        </div>
      ),
    },
  ];

  // List Pagination Payload
  const [listPayload, setListPayload] = useState({
    limit: 10,
    offset: 0,
    vendor_id: null,
    company_id: null,
    bill_month: null,
  });

  const filterButtonDisable =
    listPayload.vendor_id == null &&
    listPayload.company_id == null &&
    listPayload.bill_month == null;

  const fetchSummaryData = async () => {
    try {
      const response = await getOverviewData();
      if (response.status === 200) {
        let overviewData = response?.data?.invoices.overview;
        overviewData = overview?.map((item) => ({
          ...item,
          value: overviewData[item.id],
        }));
        setOverview(overviewData);
      }
    } catch (error) {
      toast.error("Error fetching imprest data.");
    }
  };

  const fetchListData = async ({
    limit = 10,
    offset = 0,
    vendor_id = null,
    company_id = null,
    bill_month = null,
  }) => {
    try {
      const payload = {
        limit,
        offset,
        vendor_id,
        company_id,
        search: bill_month,
      };
      const response = await getListData(payload);
      if (response?.status === 200) {
        let listDatas = response?.data?.invoices?.data?.map((item) => ({
          vendorName: item?.vendor?.name,
          invoiceNo: item?.invoice_number,
          month: item?.bill_month,
          amount: item?.total_amount,
          paymentDate: item.payment_date || null,
          tdsDeducted: null,
          paymentTxnId: item.transaction_id || null,
          paymentStatus: item.status,
        }));
        setListData(listDatas);
        setTotalLengthListData(listDatas?.total);
      }
    } catch (error) {
      toast.error("Error fetching imprest data.");
    }
  };

  const fetchCompanyListData = async () => {
    try {
      const response = await getCompanyList();
      if (response.status === 200) {
        let companyData = response?.data?.data;
        companyData = companyData?.map((item) => ({
          label: `${item.company_name} - ${item.state}`,
          value: item.id,
        }));
        setCompanyOptions(companyData);
      }
    } catch (error) {
      toast.error("Error fetching imprest data.");
    }
  };

  const fetchVendorListData = async () => {
    try {
      const response = await getVendorList();
      if (response.status === 200) {
        let vendorListData = response?.data?.data;
        vendorListData = vendorListData?.map((item) => ({
          label: item.name,
          value: item.id,
        }));
        setVendorOptions(vendorListData);
      }
    } catch (error) {
      toast.error("Error fetching imprest data.");
    }
  };

  useEffect(() => {
    fetchSummaryData();
    fetchVendorListData();
    fetchCompanyListData();
    fetchListData(listPayload);
  }, []);

  const applyFilterHandler = () => {
    fetchListData(listPayload);
  };

  const applyResetrHandler = () => {
    fetchListData({
      ...listPayload,
      vendor_id: null,
      company_id: null,
      bill_month: null,
    });

    setListPayload((pre) => ({
      ...pre,
      vendor_id: null,
      company_id: null,
      bill_month: null,
    }));
  };

  const paginationHandler = (page, limit) => {
    fetchListData({
      ...listPayload,
      limit,
      offset: page * limit - limit,
    });

    setListPayload((pre) => ({
      ...pre,
      limit,
      offset: page * limit - limit,
    }));
  };

  return (
    <Layout className="min-h-screen bg-gray-50">
      <div
        style={{
          marginBottom: 24,
          color: "#0471a3",
          fontSize: "1.5rem",
          fontWeight: 600,
        }}
      >
        Vendor Bills
      </div>
      <Content className="p-6">
        <div className="max-w-7xl mx-auto">
          {/* Summary Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 mb-12">
            {overview?.map((card) => (
              <DashboardCard
                key={card.id}
                card={card}
                isSelected={false}
                onClick={() => {}}
              />
            ))}
          </div>

          {/* Filter Section */}
          <div className="flex gap-4 mt-4 mb-6 items-center">
            <div className="w-[25%]">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Vendor
              </label>
              <Select
                placeholder="Select Vendor"
                value={listPayload.vendor_id}
                onChange={(value) =>
                  setListPayload((pre) => ({
                    ...pre,
                    vendor_id: value === undefined ? null : value,
                  }))
                }
                style={{ width: "100%" }}
                allowClear
              >
                {vendorOptions.map((option) => (
                  <Option key={option.value} value={option.value}>
                    {option.label}
                  </Option>
                ))}
              </Select>
            </div>
            <div className="w-[25%]">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Company Name
              </label>
              <Select
                placeholder="Select Company"
                value={listPayload.company_id}
                onChange={(value) =>
                  setListPayload((pre) => ({
                    ...pre,
                    company_id: value === undefined ? null : value,
                  }))
                }
                style={{ width: "100%" }}
                allowClear
              >
                {companyOptions.map((option) => (
                  <Option key={option.value} value={option.value}>
                    {option.label}
                  </Option>
                ))}
              </Select>
            </div>
            <div className="w-[25%]">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Month
              </label>
              <Input
                className="inoi"
                placeholder={"Search Month"}
                value={listPayload.bill_month}
                onChange={(e) =>
                  setListPayload((pre) => ({
                    ...pre,
                    bill_month:
                      e.target.value.length === 0 ? null : e.target.value,
                  }))
                }
              />
            </div>
            <div className="flex flex-col">
              <label className="invisible text-sm font-medium text-gray-700 mb-1">
                Apply
              </label>
              <Button
                onClick={applyFilterHandler}
                type="primary"
                disabled={filterButtonDisable}
                style={{
                  backgroundColor: filterButtonDisable ? "#f0f0f0" : "#0471a3",
                  borderColor: filterButtonDisable ? "#d9d9d9" : "#0471a3",
                  color: filterButtonDisable ? "#a0a0a0" : "#fff",
                  cursor: filterButtonDisable ? "not-allowed" : "pointer",
                  boxShadow: "none",
                }}
              >
                Apply Filter
              </Button>
            </div>
            <div className="flex flex-col">
              <label className="invisible text-sm font-medium text-gray-700 mb-1">
                Reset
              </label>
              <Button
                onClick={applyResetrHandler}
                type="primary"
                disabled={filterButtonDisable}
                style={{
                  backgroundColor: "#0471a3",
                  borderColor: "#0471a3",
                  color: "#fff",
                  cursor: "pointer",
                  boxShadow: "none",
                }}
              >
                Reset Filter
              </Button>
            </div>
          </div>

          {/* Client Summary Table */}
          <div className="">
            <Table
              columns={columns}
              dataSource={listData}
              bordered
              pagination={false}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                marginTop: 16,
                marginBottom: 16,
                marginRight: 10,
                textAlign: "right",
              }}
            >
              <Pagination
                showQuickJumper
                total={totalLengthListData}
                showSizeChanger={true}
                pageSizeOptions={["10", "20", "50", "100"]}
                onChange={paginationHandler}
              />
            </div>
          </div>

          {/* I N F O R M A T I O N   M D O A L */}
          <PaymentDetailsModal
            visible={listItemModalDetails.isOpen}
            setLIstItemModalDetails={setLIstItemModalDetails}
            paymentDetails={listItemModalDetails}
          />
        </div>
      </Content>
    </Layout>
  );
};

export default Vendorbills;

const PaymentDetailsModal = ({
  visible,
  setLIstItemModalDetails,
  paymentDetails,
}) => {
  return (
    <Modal
      title={
        <Title level={4} style={{ margin: 0, color: "#1a3c6d" }}>
          Payment Details
        </Title>
      }
      visible={visible}
      onCancel={() =>
        setLIstItemModalDetails({
          paymentDate: null, // ISO format or valid date string
          tdsDeducted: null,
          paymentTxnId: null,
          isOpen: false,
        })
      }
      footer={null}
      centered
      width={600}
      bodyStyle={{
        padding: "24px",
        backgroundColor: "#f9fafb",
      }}
      style={{
        borderRadius: "8px",
      }}
    >
      <Descriptions
        bordered
        column={1}
        labelStyle={{
          width: "40%",
          fontWeight: 500,
          backgroundColor: "#f0f2f5",
          padding: "12px",
          color: "#1a3c6d",
          fontSize: "14px",
        }}
        contentStyle={{
          padding: "12px",
          backgroundColor: "#ffffff",
          fontSize: "14px",
          color: "#333",
        }}
        style={{
          borderRadius: "6px",
          overflow: "hidden",
        }}
      >
        <Descriptions.Item label="Payment Date">
          <span style={{ fontWeight: 400 }}>
            {paymentDetails?.paymentDate
              ? dayjs(paymentDetails.paymentDate).format("DD MMMM YYYY")
              : "N/A"}
          </span>
        </Descriptions.Item>
        <Descriptions.Item label="TDS Deducted">
          <span style={{ fontWeight: 400 }}>
            {paymentDetails?.tdsDeducted
              ? `₹${paymentDetails.tdsDeducted.toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`
              : "N/A"}
          </span>
        </Descriptions.Item>
        <Descriptions.Item label="Payment Transaction ID">
          <span style={{ fontWeight: 400 }}>
            {paymentDetails?.paymentTxnId || "N/A"}
          </span>
        </Descriptions.Item>
      </Descriptions>
    </Modal>
  );
};
